import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Header, Footer } from "./headerFooter";
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import { getHost } from './config';
import { useNavigate, Link } from 'react-router-dom';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [touched, setTouched] = useState({ password: false, confirmPassword: false });
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const passwordIsValid =
        password.length >= 6 &&
        password.length <= 20 &&
        /[a-zA-Z]/.test(password) &&
        /\d/.test(password);

    const confirmPasswordIsValid = confirmPassword === password && confirmPassword !== "";

    
    const handleReset = async (event) => {
        event.preventDefault();
        setError("");
        setMessage("");
        setTouched({ password: true, confirmPassword: true });

        try {
            const url = `${getHost()}/api/reset-password`

            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, password }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(data.message || "Ο κωδικός άλλαξε επιτυχώς!");
                setPassword("");
                setConfirmPassword("");
                setTouched({ password: false, confirmPassword: false });
            } else {
                setError(data.message || "Απέτυχε η αλλαγή κωδικού.");
                setSuccess("" || "Επιτυχής εγγραφή");
            }
        } catch {
            setError("Προέκυψε σφάλμα. Προσπαθήστε ξανά αργότερα.");
        }
    };

    const isFormValid = password !== '' && confirmPassword !== '';
    
    return (
        <div id="root">
            <Header />
            <main className='center-container'>
                <Container className='custom-container p-3'>
                    {error && <Alert className='alert-error'>
                        {error}
                    </Alert>}

                    {success ? (
                        <div className="result">
                        <Alert className="alert-success">{success}</Alert>
                        <Button onClick={() => navigate('/')} variant="danger">Επιστροφή στην οθόνη εισόδου</Button>
                        </div>
                    ) : (
                        <Form onSubmit={handleReset}>
                            <Form.Group className="mb-3" controlId="resetPassword.newPassword">
                                <div className="d-flex align-items-center gap-2">
                                    <Form.Label className="custom-label">Νέος κωδικός</Form.Label>
                                    <span
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                        className="mb-2"
                                        onClick={() => setShowPassword(prev => !prev)}
                                    >
                                        {showPassword ? (
                                            <i className="bi bi-eye-slash"></i>
                                        ) : (
                                            <i className="bi bi-eye"></i>
                                        )}
                                    </span>
                                </div>
                                    <Form.Control 
                                        className="custom-form pe-5" 
                                        type={showPassword ? "text" : "password"} 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value.trimEnd())}
                                        onBlur={() => setTouched((prev) => ({ ...prev, password: true }))}
                                        isInvalid={touched.password && !passwordIsValid}
                                        placeholder="Εισάγετε νέο κωδικό"
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Ο κωδικός πρέπει να έχει 6–20 χαρακτήρες, τουλάχιστον ένα γράμμα και έναν αριθμό.
                                    </Form.Control.Feedback>
                                
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="resetPassword.confirmNewPassword">
                                <div className="d-flex align-items-center gap-2">
                                    <Form.Label className="custom-label">Επιβεβαίωση Νέου Κωδικού</Form.Label>
                                    <span
                                        style={{ cursor: 'pointer', color: '#6c757d' }}
                                        className="mb-2"
                                        onClick={() => setShowConfirmPassword(prev => !prev)}
                                    >
                                        {showConfirmPassword ? (
                                            <i className="bi bi-eye-slash"></i>
                                        ) : (
                                            <i className="bi bi-eye"></i>
                                        )}
                                    </span>
                                </div>
                                <Form.Control 
                                    className="custom-form" 
                                    type={showConfirmPassword ? "text" : "password"}
                                    value={confirmPassword} 
                                    onChange={(e) => setConfirmPassword(e.target.value.trimEnd())} 
                                    onBlur={() => setTouched((prev) => ({ ...prev, confirmPassword: true }))}
                                    isInvalid={touched.confirmPassword && !confirmPasswordIsValid}
                                    placeholder="Επαναλάβετε τον νέο κωδικό"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Οι κωδικοί δεν ταιριάζουν.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Button variant="danger" type="submit" disabled={!isFormValid}>Υποβολή</Button>
                            
                        </Form>
                    )}
                
                </Container>
            </main>
            <Footer />
        </div>
    );
    }

export default ResetPassword;